




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class RadioGroup extends Vue {
    @Prop() id? : string;
    @Prop() name? : string;
    @Prop() value?: string;
    @Prop() type?: string;
    @Prop() default?: string;
    @Prop() checkClass?: string;

    private sendValue() {
        if (!this.isChecked()) {
            this.$emit('update', this.value)
        }   
    }

    private isChecked() {
        return this.default === this.value;
    }
}
